import {PieChart as RechartsPieChart, Pie, Cell, ResponsiveContainer} from 'recharts'
import {useTheme} from 'styled-components'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {StyledChartContainer} from './style'
import {useGetDashboardOps} from '../../query/useGetDashboardOps'
import {useParsedSearchParams} from '@/hooks/useParsedSearchParams'
import {DashboardSearchParams} from '../../types'
import {useMemo} from 'react'
import {useTranslation} from '@/translations/i18n'
import {DashboardProjectsPieChartSkeleton} from './DashboardProjectsPieChartSkeleton'
import {PieChartLegend, PieChartLegendData} from '../pie-chart-legend/PieChartLegend'

export const DashboardProjectsPieChart = () => {
    const {palette} = useTheme()
    const {t} = useTranslation()
    const {searchParams} = useParsedSearchParams(DashboardSearchParams)
    const {data, isLoading} = useGetDashboardOps({
        fields: ['projects'],
        ...searchParams
    })

    const chartData = useMemo(() => {
        return [
            {name: t('dashboard:pic'), value: data?.projects?.new ?? 0, color: palette.primary[400]},
            {name: t('dashboard:closed_projects'), value: data?.projects?.closed ?? 0, color: palette.primary[800]}
        ]
    }, [data?.projects, t])

    const legendData: PieChartLegendData[] = [
        {name: t('dashboard:pic'), value: data?.projects?.new ?? 0, color: palette.primary[400]},
        {name: t('dashboard:closed_projects'), value: data?.projects?.closed ?? 0, color: palette.primary[800]}
    ]

    if (isLoading) {
        return <DashboardProjectsPieChartSkeleton />
    }

    return (
        <Flexbox align="center" gap={6}>
            <StyledChartContainer>
                <ResponsiveContainer width={100} height={100}>
                    <RechartsPieChart>
                        <Pie
                            data={chartData}
                            cx="50%"
                            cy="50%"
                            innerRadius={25}
                            outerRadius={50}
                            paddingAngle={2}
                            dataKey="value"
                        >
                            {chartData.map((entry, index) => (
                                <Cell key={index} fill={entry.color} />
                            ))}
                        </Pie>
                    </RechartsPieChart>
                </ResponsiveContainer>
            </StyledChartContainer>
            <PieChartLegend data={legendData} />
        </Flexbox>
    )
}
